<!-- eslint-disable vue/multi-word-component-names -->
<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div
    class="h-screen flex flex-col lg:flex-row overflow-hidden"
    id="page-login"
  >
    <!-- Imagem de Fundo no Desktop -->
    <div
      class="hidden lg:block lg:w-1/2 relative bg-grey-button-previus overflow-hidden"
    >
      <img
        :src="imageWallpaperHome"
        class="object-right object-cover w-full h-full"
        alt="Login Background"
        v-if="imageWallpaperHome"
      />

      <img
        src="https://sinistro.bpseguradora.com.br/assets/access-area-DGsP_KZz.svg"
        class="object-cover w-full h-full"
        alt="Login Background"
        v-else
      />
    </div>

    <!-- Área do Formulário -->
    <div class="flex flex-1 h-full items-center justify-center p-6 lg:p-12">
      <div class="w-auto lg:max-w-[400px] space-y-4">
        <div class="text-center">
          <div class="h-24 flex items-center">
            <img
              v-if="logo"
              :src="logo"
              alt="Logo"
              class="h-16 lg:h-24 w-auto mx-auto"
            />
          </div>
          <div class="w-full space-y-2">
            <h1
              class="text-2xl lg:text-3xl text-primary-v2 font-poppins font-normal"
            >
              Área de Acesso
            </h1>
            <p class="text-gray-600 font-inter">
              Informe seus dados para acessar o sistema interno
            </p>
          </div>
        </div>

        <form
          role="form"
          @submit.stop.prevent="onSubmit"
          class="flex flex-col gap-4"
        >
          <div class="relative w-full">
            <label
              for="id-empresa-input"
              class="typography-body-small text-sm font-regular font-inter text-neutral-70-v2"
              >Código Empresa</label
            >
            <input
              :disabled="isBP || isPending"
              v-model="idEmpresaAux"
              type="text"
              inputMode="numeric"
              id="id-empresa-input"
              class="input border-neutral-30-v2 typography-body-medium font-poppins text-neutral-90-v2"
              @keyup.enter="selecionaEmpresa"
              @keypress="onlyNumbers"
              autocomplete="off"
              name="fake-field"
              aria-autocomplete="none"
              autocapitalize="off"
              spellcheck="false"
            />
            <button
              type="button"
              :disabled="isBP || !idEmpresaAux || isPending"
              @click.stop.prevent="selecionaEmpresa"
              id="id-empresa-button"
              class="icon-button absolute p-2 px-3 border-none rounded-lg text-primary-v2 bg-transparent h-9 right-0"
            >
              <search-icon class="w-5 h-5"></search-icon>
            </button>
          </div>

          <div class="relative w-full">
            <label
              for="email-input"
              class="typography-body-small text-sm font-regular font-inter text-neutral-70-v2"
              >E-mail</label
            >
            <input
              type="email"
              id="email-input"
              :disabled="isPending"
              v-model="form.emailConsultor"
              class="input border-neutral-30-v2 typography-body-medium font-poppins text-neutral-90-v2"
            />
          </div>

          <div class="relative w-full" v-if="!esqueciSenha">
            <label
              for="inputSenha"
              class="typography-body-small text-sm font-regular font-inter text-neutral-70-v2"
              >Senha</label
            >
            <input
              id="senha-input"
              :disabled="isPending"
              :type="tipoInputSenha"
              v-model="form.senha"
              class="input border-neutral-30-v2 typography-body-medium font-poppins text-neutral-90-v2"
            />
            <button
              :disabled="isPending"
              type="button"
              @click.stop.prevent="exibirSenha"
              id="password-button"
              class="icon-button absolute p-2 px-3 border-none rounded-lg cursor-pointer text-primary-v2 bg-transparent right-0"
            >
              <eye-icon v-if="tipoInputSenha === 'password'" class="w-5 h-5" />
              <eye-off-icon v-else class="w-5 h-5" />
            </button>
          </div>
          <div class="flex justify-end">
            <button
              id="login-button"
              class="bg-primary-v2 mt-4 font-poppins text-white px-6 py-3 inline-flex items-center justify-center h-auto rounded-full border-none cursor-pointer typography-label-large ui-button hover:bg-primary-v2-hover active:bg-primary-v2-active w-full lg:w-1/4"
              type="submit"
              :disabled="isPending"
            >
              Entrar
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import service from './../../services';
import locale from './../../locale';
import ability from './../../services/ability';
import functions from './../../utils/functions';
import {
  getDataLoginDefault,
  saveDataLoginDefault,
  saveListEmpresas,
} from './../../services/multiple-empresa';
import { decryptData } from './../../services/decryptData';
import { SearchIcon, EyeIcon, EyeOffIcon } from 'vue-feather-icons';

export default {
  data() {
    return {
      email: '',
      password: '',
      idEmpresaAux: null,
      idEmpresa: null,
      empresaSelecionada: false,
      tipoInputSenha: 'password',
      iconIputSenha: 'icon icon-eye',
      form: {
        placa: null,
        email: null,
        emailConsultor: null,
        senha: null,
        idEmpresa: null,
      },
      checkbox_remember_me: false,
      logo: '',
      esqueciSenha: false,
      contando: false,
      contador: 45,
      isBP: false,
      isPending: false,
      imageWallpaperHome: '',
    };
  },
  components: { SearchIcon, EyeIcon, EyeOffIcon },
  methods: {
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }

      return null;
    },
    onSubmit() {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return;
        }

        if (this.esqueciSenha) {
          this.validaEmailConsultor();
          return;
        }

        this.isPending = true;
        service
          .login('Login', 'makeLogin', this.form)
          .then((res) => {
            this.isPending = false;
            const {
              token,
              permission,
              idEmpresaDefault,
              empresas,
              redirect,
              trocarSenha,
            } = res.data;

            localStorage.setItem('user-token', token);
            localStorage.removeItem('hideNotificationPagtoInconsistentes');

            saveDataLoginDefault(idEmpresaDefault, token);
            saveListEmpresas(empresas);

            ability.saveLocalPermission(permission);

            if (this.$ability && permission) {
              this.$ability.update(permission);
            }

            if (trocarSenha && redirect == 'trocarSenha') {
              window.location.href = 'trocarSenha';
              return;
            }

            this.$router.push({
              path: 'dashboard',
            });
          })
          .catch((error) => {
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: error,
              color: 'danger',
            });
            this.isPending = false;
          });
      });
    },
    findLocationHostname() {
      return window.location.hostname;
    },
    getHostname() {
      const locationHostname = this.findLocationHostname();

      if (locationHostname.includes('bpmensal')) {
        this.isBP = true;
        return 'bpmensal';
      }

      if (locationHostname.includes('bemprotege')) {
        this.isBP = true;
        return 'bemprotege';
      }

      return null;
    },
    async selecionaEmpresa() {
      const objEmpresa = {
        bemprotege: 123,
        viavante: 121,
        bpmensal: 128,
      };

      const hostname = this.getHostname();

      let idEmpresa = objEmpresa[hostname] || localStorage.getItem('idEmpresa');
      const dataLoginDefault = objEmpresa[hostname] || getDataLoginDefault();

      Object.keys(objEmpresa).forEach((element) => {
        if (window.location.hostname.includes(element)) {
          idEmpresa = objEmpresa[element];
          this.form.idEmpresa = objEmpresa[element];
        }
      });

      //#region Local Storage

      if (dataLoginDefault) {
        const { idEmpresaDefault } = dataLoginDefault;

        if (idEmpresaDefault) {
          this.form.idEmpresa = idEmpresaDefault;
        } else {
          if (idEmpresa) {
            this.form.idEmpresa = idEmpresa;
          }
        }
      }

      //#endregion

      //#region Query Params
      const idEmpresaLookup = {
        117: '123',
        118: '123',
        119: '123',
        120: '123',
      };

      const idEmpresaQueryParam = this.$route.query.idEmpresa;

      if (idEmpresaQueryParam) {
        const idEmpresa =
          idEmpresaLookup[idEmpresaQueryParam] || idEmpresaQueryParam;
        this.form.idEmpresa = idEmpresa;
        saveDataLoginDefault(idEmpresa);
      }

      //#endregion

      //#region Input

      const idEmpresaInput = this.idEmpresaAux;
      if (idEmpresaInput) {
        this.form.idEmpresa = idEmpresaInput;
        saveDataLoginDefault(idEmpresaInput);
      }

      //#endregion

      if (this.form.idEmpresa) {
        localStorage.setItem('idEmpresa', this.form.idEmpresa);
        await this.buscaDadosEmpresa();
      }
    },
    buscaDadosEmpresa() {
      this.isPending = true;

      return new Promise((resolve) => {
        service
          .getAll('g', {}, 'empresas/list/idEmpresa/' + this.form.idEmpresa)
          .then((res) => {
            res.data = decryptData(res.data);
            this.logo = res.data[0].logo;
            this.imageWallpaperHome = res.data[0].imageWallpaperHome;
            localStorage.setItem('logo', this.logo);
            this.$store.dispatch('updateLogo', this.logo);
            this.idEmpresaAux = this.form.idEmpresa;
            this.empresaSelecionada = true;
            this.isPending = false;
            resolve();
          })
          .catch(() => {
            const erroConexao =
              'Seu aplicativo parece estar offline, verifique sua conexao';
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: erroConexao,
              color: 'danger',
            });
            service.maintenance(this.$router);
            this.empresaSelecionada = false;
            this.isPending = false;
          });
      });
    },
    exibirSenha() {
      if (this.tipoInputSenha !== 'password') {
        this.tipoInputSenha = 'password';
        this.iconIputSenha = 'icon icon-eye';
        return;
      }

      this.tipoInputSenha = 'text';
      this.iconIputSenha = 'icon icon-eye-off';
    },
    validaEmailConsultor() {
      this.isPending = true;
      service
        .post('Login', 'valida-email-consultor', this.form)
        .then((res) => {
          this.isPending = false;
          if (!res.data.length) {
            this.notify(
              'Não foi encontrado nenhum consultor com email informado',
              'danger',
            );
            return;
          }
          this.esqueciSenha = false;
          this.contagemRegressiva();
          const message = this.getMessage({ data: res.data[0] });
          this.notify(message, 'success');
        })
        .catch((event) => {
          this.isPending = false;
          this.notify(event, 'danger');
        });
    },
    getMessage(res) {
      // Não excluir habilitar opção quando a mensageria via whatsapp for restabelecida
      // if (res.data.sentWhatsapp && res.data.celular) {
      //   return `Sua nova senha foi enviada via mensagem no WhatsApp para o celular ${functions.escondeCelular(
      //     res.data.celular,
      //   )}`;
      // }

      if (res.data.celular || res.data.sentWhatsapp) {
        return `Sua nova senha foi enviada para o celular ${functions.escondeCelular(
          res.data.celular,
        )}`;
      }

      if (res.data.email) {
        return `Sua nova senha foi enviada para o email ${functions.escondeEmail(
          res.data.email,
        )}`;
      }
    },
    notify(mensagem, tipo) {
      this.$vs.notify({
        position: 'top-center',
        title: 'Atenção',
        text: mensagem,
        color: tipo,
      });
    },
    contagemRegressiva() {
      this.mostrarContador();
      const diminuir1Segundo = setInterval(() => {
        this.contador--;

        if (this.contador === 0) {
          clearInterval(diminuir1Segundo);
          localStorage.removeItem('contando');
          this.mostrarContador();
        }
      }, 1000);
    },
    mostrarContador() {
      this.contando = !this.contando;
      this.contador = 45;
    },
    verificarSeContando() {
      if (localStorage.getItem('contando')) {
        this.contagemRegressiva();
      }
    },
    onlyNumbers(event) {
      if (!/[0-9]/.test(event.key)) {
        event.preventDefault();
      }
    },
  },
  mounted() {
    service.maintenance(this.$router);
    this.$validator.localize('ptBr', locale);
    this.selecionaEmpresa();
    this.verificarSeContando();
  },
};
</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');

#inputSenha {
  padding: 0.5rem;
}

.esqueciSenhaLink {
  cursor: pointer;
}

.esqueciSenhaLink:hover {
  text-decoration: underline;
}

.esqueciSenhaLink:disabled {
  color: #6d6d6d !important;
  cursor: not-allowed !important;
}

html {
  font-size: 16px;
}

.text-gray-600 {
  color: rgb(75 85 99 / 1);
}

.typography-label-large {
  font-size: 0.875rem;
  line-height: 20px;
  letter-spacing: 0.25px;
  font-weight: 500;
}

.typography-body-small {
  font-size: 0.75rem;
  line-height: 16px;
  letter-spacing: 0.25px;
  font-weight: 400;
}

.typography-body-medium {
  font-size: 0.875rem;
  line-height: 20px;
  letter-spacing: 0.25px;
  font-weight: 400;
}

.font-poppins {
  font-family: 'Poppins', sans-serif;
  font-style: normal;
}

.font-inter {
  font-family: 'Inter', sans-serif;
  font-style: normal;
}

.input {
  width: 100%;
  padding: 0.5rem;
  height: 2.25rem;
  border: 1px solid;
  border-radius: 0.25rem;
  background-color: white;
}

.input:disabled {
  background-color: #ededed;
  border: 1px solid;
  border-radius: 0.25rem;
  border-color: #d5d5d5;
  cursor: not-allowed;
}

.icon-button {
  cursor: pointer;
}

.icon-button:disabled {
  cursor: not-allowed;
}

.ui-button:disabled {
  background-color: #d5d5d5 !important;
  color: #6d6d6d !important;
  cursor: not-allowed !important;
}
</style>
